/**
 * Converts a string to uppercase, supporting generic string types.
 *
 * @param input - The string to convert to uppercase.
 * @returns The input string converted to uppercase.
 */
export const upperCase = <T extends string>(input: T) => input.toUpperCase() as Uppercase<T>;
